const ZegoMenuBarButtonName = {
    toggleMicrophoneButton: 0,
    toggleCameraButton: 1,
    switchCameraButton: 2,
    switchAudioOutputButton: 3,
    hangUpButton: 4,
    showMemberListButton: 5,
    minimizingButton: 6,
    messageButton: 7,
}

export default ZegoMenuBarButtonName;